// import { getModels } from './models'

import { urlRewrite } from "./urlsRewrite"

const isEmpty = require('lodash.isempty')
// const natural = require('natural')
const axios = require('axios')
const cheerio = require('cheerio')

const getDomainOrigin = () => {
  const domains = []
  domains['reescrever.app'] = 'https://api-prod-client.reescrever.app'
  domains['dev.reescrever.app'] = 'https://api-dev-client.reescrever.app'
  domains['staging.reescrever.app'] = 'https://api-staging-client.reescrever.app'
  domains.localhost = 'http://localhost:8080/dev'

  const domainOrigin = window.location.hostname

  return domains[domainOrigin.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i)[1]] || 'https://api-prod-client.reescrever.app'
}


/**
 * @param {string} html - HTML contendo texto que será parafraseado posteriormente
 * @summary Remove tags de sem utilidade
 * @description Remove tags inúteis
 */
const removeInvalidTags = (html) => {
  html = html.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, '')
  html = html.replace(/<p>\s*<\/p>/ig, '');
  html = html.replace(/<p\s*\/>/ig, '');
  return html
}


/**
 * @param {string} html - HTML recebido para fazer a paráfrase
 * @summary Retorna HTML (errado) + Frases para parafrasear
 * @description Retira todas frases do HTML e troca por $$$$$[position]$$$$$, para posteriormente quando realizar paráfrase fazer o replace no lugar correto
 */
const getPhrasesToParaphrase = (html, trial) => {
  const $ = cheerio.load(html)
  const sentences = []
  // $('p, h1, h2, h3, h4, h5, h6').each(function () {
  $('p').each(function () {
    // console.log('$(this).html():', $(this).html())
    // console.log('$(this).text():', $(this).text())
    const lines = $(this).html().split(/<br>|<br\/>|<br \/>/)
    lines.forEach((line) => { sentences.push(line) })
  })

  $('li').each(function () {
    sentences.push($(this).html().split('\n')[0])
  })

  return sentences
}



// /**
//  * @param {array} phrases - Frases que serão parafraseadas
//  * @summary Parafraseia as frases
//  * @description Faz a paráfrase de todas as frases do texto. Em alguns casos, as frases possui mais de uma sentença,então elas são parafraseadas separadamente
//  */
// const sentences = async (phrases) => Promise.map(phrases, async (phrase) => {
//   // console.log('phrase:', phrase)
//   // console.log('cheerio.load(phrase).text():', cheerio.load(phrase).text())
//   let sentences = tokenizer.tokenize(cheerio.load(phrase).text())

//   // const sentences2 = tokenizer.tokenize(phrase.replace(/(\s|)<[^>]*>(\s|)/g, (a, b) => ` ${a.trim()} `))
//   const sentences2 = tokenizer.tokenize(phrase)
//   sentences = [...new Set([...sentences, ...sentences2])]
//   // console.log('sentences3:', sentences)

//   // verifica se alguma das sentenças possui tag html ao redor
//   // sentences = sentences.map(sentence => {
//   //   if (phrase.match(new RegExp(`<[^>]*>${sentence}<[^>]*>`, 'g'))) { return phrase.match(new RegExp(`<[^>]*>${sentence}<[^>]*>`, 'g'))[0] }
//   //   // else if ((sentence.match(/<[^>]*>/g) || []).length > 2)

//   //   return sentence
//   // })
//   // console.log('sentences4:', sentences)

//   let next = false
//   for (const [index, value] of sentences.entries()) {
//     if (next) {
//       delete sentences[index]
//       next = !next
//     } else if (value.trim().split(' ').length - 1 < 5) {
//       if (sentences.length - 1 !== index) {
//         sentences[index] = `${sentences[index]} ${sentences[index + 1]}`
//         next = true
//       } else if (index > 0) {
//         // verifica se não é o primeiro, caso seja o último e o primeiro ao mesmo tempo (só uma sentença)
//         let i = 1
//         while (i < 5) {
//           if (!isEmpty(sentences[index - i])) {
//             sentences[index - i] = `${sentences[index - i]} ${sentences[index]}`
//             delete sentences[index]
//             if (sentences[index - i].trim().split(' ').length - 1 > 5) break;
//           }
//           i++
//         }
//       }
//     }
//   }

//   // remove itens vazios do array
//   sentences = sentences.filter((n) => n)

//   return sentences
// })

const retry = 3
/**
 * @param {string} text - Create paraphrase from sentence
 */
const paraphraseSentence = async ({
  text, sentence, modelToRemove, modelsToRemove, domainOrigin
}) => {
  if (!isEmpty(modelToRemove)) {
    modelsToRemove.push(modelToRemove)
    modelsToRemove = modelsToRemove.join(',')
  }

  const { models } = await axios.post(`${domainOrigin}/paraphrase/models`, { text, modelsToRemove })
    .then((response) => response.data)
    .catch(async (err) => { console.log('ERRO', err) })


  const data = await axios.post(await urlRewrite(), { text, models })
    .then((response) => response.data)
    .catch(async (err) => { console.log('ERRO', err) })

  return axios.post(`${domainOrigin}/paraphrase/sentence`, {
    text, textRewrited: data, models: '', modelsToRemove: '', retry: !!retry
  })
    .then((response) => {
      response.data.text = text
      response.data.sentence = sentence
      return response.data
    })
    .catch(async (err) => {
      console.log('ERRO', err)
      return "error"
    })
}

export {
  removeInvalidTags, getPhrasesToParaphrase, getDomainOrigin, paraphraseSentence
}
